(() => {
  const colorFallbacks = {
    'off white': '#f7f3ed',
    cream: '#fffdd0',
    beige: '#ead6a5',
    taupe: '#a99b8d',
    'light blue': '#67cfe8',
    'sky blue': '#87ceeb',
    grey: '#8c8c8c'
  };

  const enhanceColorSwatches = (section) => {
    section.querySelectorAll('.product-form__input--swatch .swatch-input__label').forEach((label) => {
      const swatch = label.querySelector('.swatch');
      const colorName = label.getAttribute('title')?.trim().toLowerCase();
      if (!swatch || !colorName) return;

      const color = colorFallbacks[colorName] || colorName.replace(/\s+/g, '');
      if (CSS.supports('color', color)) swatch.style.setProperty('--swatch--background', color);
    });
  };

  const enhanceMainProducts = (scope = document) => {
    const sections = [];
    if (scope.matches?.('.main-product-custom')) sections.push(scope);
    scope.querySelectorAll?.('.main-product-custom').forEach((section) => sections.push(section));

    sections.forEach((section) => {
      section.classList.add('main-product-custom--ready');
      enhanceColorSwatches(section);
    });
  };

  enhanceMainProducts();
  document.addEventListener('shopify:section:load', (event) => enhanceMainProducts(event.target));
  document.addEventListener('product-info:loaded', (event) => enhanceMainProducts(event.target));
})();
